<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class=" font-weight-bold text-capitalize light--text" color="primary"> <v-icon class="me-1" small>mdi-plus</v-icon> Add </v-btn>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Add Gateway Charges</span>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container class="mt-2">
            <v-form @submit="updateFaq()" v-model="valid" ref="form">
              <v-layout wrap>
                <!-- <v-flex xs12 sm2 md2 class="mt-3">
                  <h4 class="text-body-2 dark--text">Type No.</h4>
                </v-flex>
                <v-flex xs12 sm7 md3 class="mx-4">
                  <v-text-field
                    solo
                    name="input-7-4"
                    label="Type"
                    v-model="type"
                    :rules="[requiredValidator('type')]"
                  ></v-text-field>
                </v-flex> -->

                <v-flex xs12 sm2 md2 class="mt-3">
                  <h4 class="text-body-2 dark--text">Transaction Type</h4>
                </v-flex>
                <v-flex xs12 sm7 md3>
                  <v-text-field solo name="input-7-4" label="Transaction Type" v-model="transactionType" :rules="[requiredValidator('transactionType')]"></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12 sm2 md2 class="mt-3">
                  <h4 class="text-body-2 dark--text">Type</h4>
                </v-flex>
                <v-flex xs12 sm7 md3 class="mx-4">
                  <v-checkbox solo name="input-7-4" label="In Percentage" v-model="isInPercentage"></v-checkbox>
                </v-flex>

                <v-flex xs12 sm2 md2 class="mx-4 mt-3">
                  <h4 class="text-body-2 dark--text">Charge</h4>
                </v-flex>
                <v-flex xs12 sm7 md3>
                  <v-text-field solo name="input-7-4" type="number" label="Transaction Type" v-model="transactionCharge" :rules="[requiredValidator('transaction charge')]">
                    <template v-slot:append>
                      <v-icon v-show="isInPercentage"> mdi-percent </v-icon>
                    </template>
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="justify-end mt-n8">
          <v-btn
            color="primary"
            class="mb-2 light--text mb-sm-4 text-capitalize"
            :width="$vuetify.breakpoint.smAndUp ? 120 : 90"
            @click="createPaymentGatewayCharge"
            :loading="btnloading"
            :disabled="!valid"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../core/methods/validations";

export default {
  data() {
    return {
      btnloading: false,
      valid: true,
      errors: [],
      snackbar: false,
      text: "",
      gateway: "TAP",
      transactionType: "",
      transactionCharge: 0,
      isInPercentage: true,
      type: "",
      show_dialog_box: false,
      requiredValidator: requiredValidator,
    };
  },
  methods: {
    close() {
      this.show_dialog_box = false;
    },
    createPaymentGatewayCharge() {
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("../api/createPaymentGatewayCharge.graphql"),
          variables: {
            transactionType: this.transactionType,
            type: parseInt(this.type),
            transactionCharge: parseFloat(this.transactionCharge),
            isInPercentage: this.isInPercentage,
            gateway: this.gateway,
          },
          update: (store, { data: { createPaymentGatewayCharge } }) => {
            try {
              const query = {
                query: require("../api/getPaymentGatewayCharges.graphql"),
              };

              let allData = store.readQuery(query);

              allData.getPaymentGatewayCharges.unshift(createPaymentGatewayCharge); //push to top
              store.writeQuery({
                ...query,
                data: allData,
              });

              this.text = "Gateway Charge Added";
              this.snackbar = true;
              this.btnloading = false;
              this.show_dialog_box = false;
              this.$refs.form.reset();
            } catch (e) {
              console.log("Something bad happend");
              console.log(e);
              this.btnloading = false;
            }

            this.show_dialog_box = false;
            this.btnloading = false;
          },
        })

        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
          this.show_dialog_box = false;
        });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
